/**
 * Importing SVG assets
 */

export const iconHome = process.env.PUBLIC_URL + '/icons/Home-Line.svg';
export const iconReward = process.env.PUBLIC_URL + '/icons/Reward-Line.svg';
export const iconCreate = process.env.PUBLIC_URL + '/icons/Create-Line.svg';
export const iconSupport = process.env.PUBLIC_URL + '/icons/Support-Line.svg';
export const iconProfile = process.env.PUBLIC_URL + '/icons/Profile-Line.svg';
export const iconView = process.env.PUBLIC_URL + '/SKOR-Icon-View.svg';
export const iconBack = process.env.PUBLIC_URL + '/SKOR-Icon-Back.svg';
export const iconFilter = process.env.PUBLIC_URL + '/SKOR-Icon-Filter.svg';
export const iconCheck = process.env.PUBLIC_URL + '/icons/Check-Green.svg';
export const iconLock = process.env.PUBLIC_URL + '/icons/Lock.svg';
export const iconPolicy = process.env.PUBLIC_URL + '/icons/Policy.svg';
export const iconPrivacy = process.env.PUBLIC_URL + '/icons/Privacy.svg';
export const iconSetting = process.env.PUBLIC_URL + '/icons/Setting.svg';
export const iconBadge = process.env.PUBLIC_URL + '/icons/Badge.svg';
export const iconIdcard = process.env.PUBLIC_URL + '/icons/Idcard.svg';
export const iconOval = process.env.PUBLIC_URL + '/icons/Oval.svg';
export const iconQrcode = process.env.PUBLIC_URL + '/icons/Qrcode.svg';
export const iconStar = process.env.PUBLIC_URL + '/icons/Star.svg';
export const iconEmail = process.env.PUBLIC_URL + '/icons/Email.svg';
export const iconWeb = process.env.PUBLIC_URL + '/icons/Web.svg';
export const iconProfileLevel =
  process.env.PUBLIC_URL + '/icons/Profile-Level.svg';
export const iconNotification =
  process.env.PUBLIC_URL + '/icons/Notification-Line.svg';
export const iconTopup = process.env.PUBLIC_URL + '/icons/Topup.svg';
export const iconEvoucher = process.env.PUBLIC_URL + '/icons/Evoucher.svg';
export const iconDonation = process.env.PUBLIC_URL + '/icons/Donation.svg';
export const iconEcommerce = process.env.PUBLIC_URL + '/icons/Ecommerce.svg';
export const iconArrowLeft = process.env.PUBLIC_URL + '/icons/Arrow-Left.svg';
export const iconArrowRight = process.env.PUBLIC_URL + '/icons/Arrow-Right.svg';
export const iconCrossMark = process.env.PUBLIC_URL + '/icons/Cross-Mark.svg';
export const iconNews = process.env.PUBLIC_URL + '/icons/News.svg';
export const iconQuiz = process.env.PUBLIC_URL + '/icons/Quiz.svg';
export const iconLikeSolid = process.env.PUBLIC_URL + '/icons/Like-Solid.svg';
export const iconLikeActive = process.env.PUBLIC_URL + '/icons/Like-Active.svg';
export const iconCommentSolid =
  process.env.PUBLIC_URL + '/icons/Comment-Solid.svg';
export const iconCalendar = process.env.PUBLIC_URL + '/icons/Calendar.svg';
export const iconBookmarkSolid =
  process.env.PUBLIC_URL + '/icons/Bookmark-Solid.svg';
export const iconBookmarkActive =
  process.env.PUBLIC_URL + '/icons/Bookmark-Active.svg';
export const iNotFound = process.env.PUBLIC_URL + '/not-found.svg';
export const iconSurvey = process.env.PUBLIC_URL + '/icons/Survey.svg';
export const bgQuiz = process.env.PUBLIC_URL + '/default-quiz.svg';
export const iconCheckOrange =
  process.env.PUBLIC_URL + '/icons/Check-Orange.svg';
export const iconFood = process.env.PUBLIC_URL + '/icons/Food.svg';
export const iconHealt = process.env.PUBLIC_URL + '/icons/Healt.svg';
export const iconLifestyle = process.env.PUBLIC_URL + '/icons/Lifestyle.svg';
export const iconEssential = process.env.PUBLIC_URL + '/icons/Essential.svg';

export const iconHomeActive = process.env.PUBLIC_URL + '/icons/Home-Solid.svg';
export const iconRewardActive =
  process.env.PUBLIC_URL + '/icons/Reward-Solid.svg';
export const iconCreateActive =
  process.env.PUBLIC_URL + '/icons/Create-Solid.svg';
export const iconSupportActive =
  process.env.PUBLIC_URL + '/icons/Support-Solid.svg';
export const iconProfileActive =
  process.env.PUBLIC_URL + '/icons/Profile-Solid.svg';
export const iconSupportCall =
  process.env.PUBLIC_URL + '/icons/Support-Call.svg';
export const iconViewActive =
  process.env.PUBLIC_URL + '/SKOR-Icon-View-line.svg';
export const iconEditActive = process.env.PUBLIC_URL + '/icons/Edit-Solid.svg';
export const iconLogoutActive =
  process.env.PUBLIC_URL + '/icons/Logout-Solid.svg';
export const iconBackWhite = process.env.PUBLIC_URL + '/icons/Back-White.svg';
export const iconQmark = process.env.PUBLIC_URL + '/icons/Qmark.svg';
export const iconRewardWhite =
  process.env.PUBLIC_URL + '/icons/Reward-White.svg';
export const iconTokopedia = process.env.PUBLIC_URL + '/icons/Tokopedia.svg';
export const iconLockBlack = process.env.PUBLIC_URL + '/icons/Lock-Black.svg';
export const iconCreatePost = process.env.PUBLIC_URL + '/icons/Create-Post.svg';
export const iconSubmit =
  process.env.PUBLIC_URL + '/icons/Create-Post-Submit.svg';
export const iconCreatePostFile =
  process.env.PUBLIC_URL + '/icons/Create-Post-File.svg';
export const iconCreatePostAddFile =
  process.env.PUBLIC_URL + '/icons/Create-Post-Add-File.svg';
export const iconCreatePostFileDoc =
  process.env.PUBLIC_URL + '/icons/Create-Post-File-Doc.svg';
export const iconCreatePostFilePdf =
  process.env.PUBLIC_URL + '/icons/Create-Post-File-Pdf.svg';
export const iconCreatePostFilePpt =
  process.env.PUBLIC_URL + '/icons/Create-Post-File-Ppt.svg';
export const iconCreatePostFileXls =
  process.env.PUBLIC_URL + '/icons/Create-Post-File-Xls.svg';
export const iconCreatePostPhoto =
  process.env.PUBLIC_URL + '/icons/Create-Post-Photo.svg';
export const iconCreatePostVideo =
  process.env.PUBLIC_URL + '/icons/Create-Post-Video.svg';
export const iconCreatePostDefaultImage =
  process.env.PUBLIC_URL + '/icons/Create-Post-Default-Image.svg';
export const iconCreatePostCloseImage =
  process.env.PUBLIC_URL + '/icons/Create-Post-Close-Image.svg';
export const iconCreatePostDefaultPreview =
  process.env.PUBLIC_URL + '/icons/Create-Post-Default-Preview.svg';

/**
 * Importing Png Asset
 */
export const iconSupportPeople =
  process.env.PUBLIC_URL + '/icons/Support-Person.png';
export const logo = process.env.PUBLIC_URL + '/SKOR-Logo.png';
export const logoWhite = process.env.PUBLIC_URL + '/SKOR-Logo-White.png';
export const splashBackground =
  process.env.PUBLIC_URL + '/splash-screen-new.svg';
export const baseLogo = process.env.PUBLIC_URL + '/base_logo.png';

export const sosmedFB = process.env.PUBLIC_URL + '/sosmed/004-facebook.png';
export const sosmedIG = process.env.PUBLIC_URL + '/sosmed/001-instagram.png';
export const sosmedTW = process.env.PUBLIC_URL + '/sosmed/003-twitter.png';
export const sosmedLN = process.env.PUBLIC_URL + '/sosmed/006-linkedin.png';
export const sosmedMail = process.env.PUBLIC_URL + '/sosmed/002-mail.png';

export const page_not_found = process.env.PUBLIC_URL + '/page_not_found.png';
export const page_under_construct =
  process.env.PUBLIC_URL + '/page_under_construct.png';

export const iconEye = process.env.PUBLIC_URL + '/view.png';
export const iconEyeActive = process.env.PUBLIC_URL + '/view-active.png';
export const placeholder = process.env.PUBLIC_URL + '/placeholder.png';
export const iconGoldCoin = process.env.PUBLIC_URL + '/icons/GoldCoin.png';
export const iconClock = process.env.PUBLIC_URL + '/icons/Clock.png';
export const iconPeople = process.env.PUBLIC_URL + '/icons/People.png';
export const iconCheckQuiz = process.env.PUBLIC_URL + '/icons/Check.png';
export const iconPointMaps = process.env.PUBLIC_URL + '/icons/PointMaps.png';
export const iconDirection = process.env.PUBLIC_URL + '/icons/Direction.png';
export const iconQrScan = process.env.PUBLIC_URL + '/icons/Qrcodescan.png';
export const iconCheckSurvey =
  process.env.PUBLIC_URL + '/icons/Check-White.png';
export const iconClose = process.env.PUBLIC_URL + '/icons/Icon-Close.svg';
export const iconAnnouncement =
  process.env.PUBLIC_URL + '/icons/Announcement.svg';
export const iconPolling = process.env.PUBLIC_URL + '/icons/Polling.png';
export const iconEvent = process.env.PUBLIC_URL + '/icons/Event.svg';
export const iconCheckCircleWhite =
  process.env.PUBLIC_URL + '/icons/Check-Circle-White.png';
export const iconPinMap = process.env.PUBLIC_URL + '/icons/Pin-Map.svg';
export const iconBadgeSale = process.env.PUBLIC_URL + '/icons/Badge-Sale.svg';
export const iEventNotFound = process.env.PUBLIC_URL + '/event-not-found.svg';
export const iconQrcodeScanner =
  process.env.PUBLIC_URL + '/icons/QR-code-scanner.svg';
export const iconFacebookOrange =
  process.env.PUBLIC_URL + '/icons/Facebook-Orange.svg';
export const iconWhatsappOrange =
  process.env.PUBLIC_URL + '/icons/Whatsapp-Orange.svg';
export const iconTwitterOrange =
  process.env.PUBLIC_URL + '/icons/Twitter-Orange.svg';
export const iconLeaderboard =
  process.env.PUBLIC_URL + '/icons/Leaderboard.png';
export const iconWifiOff = process.env.PUBLIC_URL + '/icons/Wifi-Off.svg';
export const dot = process.env.PUBLIC_URL + '/icons/dot.svg';
export const iconDateCalendar = process.env.PUBLIC_URL + '/icons/Calendar.png';
export const iconCalendarAddReminder =
  process.env.PUBLIC_URL + '/icons/Calendar-Add-Reminder.png';
export const iconBackGrey = process.env.PUBLIC_URL + '/icons/Back-Grey.png';
export const iconNextGrey = process.env.PUBLIC_URL + '/icons/Next-Grey.png';
export const iconEvents = process.env.PUBLIC_URL + '/icons/Calendar-Events.png';
export const iconAppointments =
  process.env.PUBLIC_URL + '/icons/Calendar-Appointments.png';
export const iconGreetings =
  process.env.PUBLIC_URL + '/icons/Calendar-Birthday.png';
export const iconCalendarNoData =
  process.env.PUBLIC_URL + '/Calendar-No-Data.png';
export const iconCreateReport =
  process.env.PUBLIC_URL + '/icons/Create-Report.svg';
export const iconBlockUser = process.env.PUBLIC_URL + '/icons/policy_black.svg';
export const iconReceipt = process.env.PUBLIC_URL + '/icons/Receipt.svg';
export const snapReceiptNotFound =
  process.env.PUBLIC_URL + '/snap-receipt-not-found.svg';
export const bannerSnapReceipt =
  process.env.PUBLIC_URL + '/bg-header-snap-receipt.png';
export const iconPlus = process.env.PUBLIC_URL + '/ic-plus-orange.svg';
export const bgGradient = process.env.PUBLIC_URL + '/bg-gradient.png';
export const iconPlusOrange = process.env.PUBLIC_URL + '/icons/Plus-Orange.svg';
export const iconOther = process.env.PUBLIC_URL + '/icons/Other.svg';
export const iconOvalOrange = process.env.PUBLIC_URL + '/icons/Oval-Orange.svg';
export const iconOvalOrangeOne =
  process.env.PUBLIC_URL + '/icons/Oval-Orange-One.svg';
export const iconOvalOrangeTwo =
  process.env.PUBLIC_URL + '/icons/Oval-Orange-Two.svg';
export const iconOvalOne = process.env.PUBLIC_URL + '/icons/Oval-One.svg';
export const iconDeleteMenu = process.env.PUBLIC_URL + '/icons/Delete-Menu.svg';
